import React from 'react';
import appStore from '../img/Download_on_the_App_Store_Badge_US-UK_RGB_wht_092917.svg';
import playStore from '../img/google-play-badge.png';

const Footer = () => {
    return (
        <div className="footer">
            <a href="https://apps.apple.com/kr/app/%ED%83%80%EC%9D%B4%EB%A8%B8%EC%95%BC/id1562961358">
                <img className="appstore-image" src={appStore}></img>
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.jaylee.timerya">
                <img className="playstore-image" src={playStore}></img>
            </a>
            <div>
                Copyright 2021. Hyunjin Lee.
            </div>
        </div>
    );
}

export default Footer;